import { PlayerTypeResolver } from '@app/textbook/resolvers/player-type.resolver';
import { NotesResolver } from '@app/textbook/resolvers/notes.resolver';
import { MarkersResolver } from '@app/textbook/resolvers/markers.resolver';
import { TextbookDataResolver } from '@app/textbook/resolvers/textbook-data.resolver';

const resolvers = [TextbookDataResolver, PlayerTypeResolver, NotesResolver, MarkersResolver];

export { resolvers, PlayerTypeResolver, NotesResolver, MarkersResolver, TextbookDataResolver };
